module.exports = __webpack_public_path__ + "img/pro_s2_icon4.532f4f3a.png";